import React, { useState } from 'react';
import { GetServerSideProps, NextPage } from 'next';
import SearchKnowledgebaseResults from '../../components/@search/search-knowledgebase-results';
import Layout from '../../components/layout';
import InputField from '../../components/input-field';
import GenericContainer from '../../components/@container/generic-container';
import SearchProductResults from '../../components/@search/search-product-results';
import SearchSiteResults from '../../components/@search/search-site-results';
import useRoleInRequest from '../../hooks/use-role-in-request';
import usePermissionInRequest from '../../hooks/use-permission-in-request';
import Button from '../../components/button';

interface Props {
  isRetailer: boolean;
}

const SearchPage: NextPage<Props> = ({ isRetailer }) => {
  const [value, setValue] = useState('');
  const [searchValue, setSearchValue] = useState<string | null>(null);

  const onSearch = (e) => {
    e.preventDefault();
    setSearchValue(value);
  };

  return (
    <Layout title="Search">
      <GenericContainer
        title="Search"
        breadcrumb={{ text: 'Back to Home', url: '/' }}
      >
        <div className="content">
          <div className="group">
            <InputField
              cy="search-input"
              id="search"
              label="Search"
              placeholder="Search Term"
              type="text"
              defaultValue={value}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              marginBottom="0"
              padding="1rem 1rem"
            />
            <Button text="Search" onClick={onSearch} />
          </div>
          {searchValue && [
            <SearchProductResults
              value={searchValue}
              isRetailer={isRetailer}
            />,
            <SearchKnowledgebaseResults value={searchValue} />,
            <SearchSiteResults value={searchValue} />,
          ]}
        </div>
        <style jsx>{`
          .group {
            display: flex;
            flex-direction: row;
            gap: 1rem;
            align-items: end;
            margin-bottom: 1rem;
          }
        `}</style>
      </GenericContainer>
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const isRetailer = await useRoleInRequest(req, ['RETAILER']);
  const isAdmin = await usePermissionInRequest(req, 'system_admin');

  return {
    props: {
      isRetailer: isRetailer || isAdmin,
    },
  };
};

export default SearchPage;
